;(function ( $ ) {

    /**
     *  validate
     *  validate input elements
     *  data-required-msg: Display this message if field is non-empty
     *  data-invalid-email: Display this message if field is non-empty
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'validate';
    var defaults = {

    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            if ($(this.element).hasClass('required')) {
                // Event handler for required fields
                $(this.element).on('required-msg.show', function(e) {
                    e.stopPropagation();
                    var $inputWrapper = $(this).parents('fieldset');
                    $inputWrapper.addClass('has-error');
                    if ($(this).data('required-msg')) {
                        if (!$inputWrapper.find('.error-msg').length) {
                            $inputWrapper.append('<span class="error-msg">' + $(this).data('required-msg') + '</span>');
                        } else {
                            $inputWrapper.find('.error-msg').text($(this).data('required-msg'));
                            $inputWrapper.find('.error-msg').addClass('flash animated');
                            $inputWrapper.find('.error-msg').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                                $inputWrapper.find('.error-msg').removeClass('animated').removeClass('flash');
                            });
                        }
                    }
                });

                $(this.element).on('change', function() {
                    $(this).trigger('required-msg.remove');
                });

                $(this.element).on('required-msg.remove', function(e) {
                    e.stopPropagation();
                    var $inputWrapper = $(this).parents('fieldset');
                    $inputWrapper.removeClass('has-error');
                    $inputWrapper.find('.error-msg').remove();
                });
            }

            // Validation
            if ($(this.element).hasClass('validate')) {
                // Event handler for required fields
                $(this.element).on('validate-msg.show', function(e) {
                    e.stopPropagation();
                    var $inputWrapper = $(this).parents('fieldset');
                    $inputWrapper.addClass('has-error');
                    if ($(this).data('validate-msg')) {
                        if (!$inputWrapper.find('.error-msg').length) {
                            $inputWrapper.append('<span class="error-msg">' + $(this).data('validate-msg') + '</span>');
                        } else {
                            $inputWrapper.find('.error-msg').text($(this).data('validate-msg'));
                            $inputWrapper.find('.error-msg').addClass('flash animated');
                            $inputWrapper.find('.error-msg').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                                $inputWrapper.find('.error-msg').removeClass('animated').removeClass('flash');
                            });
                        }
                    }
                });

                $(this.element).on('change', function() {
                    $(this).trigger('validate-msg.remove');
                });

                $(this.element).on('validate-msg.remove', function(e) {
                    e.stopPropagation();
                    var $inputWrapper = $(this).parents('fieldset');
                    $inputWrapper.removeClass('has-error');
                    $inputWrapper.find('.error-msg').remove();
                });
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
